(() => {
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantsElement = root.querySelector('[data-variants-json]');
    if (!variantsElement) return;
    const variants = JSON.parse(variantsElement.textContent);
    const scope = root.closest('.product__info, .featured-product__content') || root.parentElement;
    const optionGroups = [...root.querySelectorAll('[data-option-position]')];
    const variantInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-add-to-cart-text]');

    const selectedOptions = () => optionGroups.map((group) => group.querySelector('input:checked')?.value || null);
    const variantOptions = (variant) => [variant.option1, variant.option2, variant.option3];
    const currentVariant = () => {
      const options = selectedOptions();
      return variants.find((variant) => variantOptions(variant).every((option, index) => !option || option === options[index]));
    };

    const updateOptionAvailability = () => {
      const selected = selectedOptions();
      optionGroups.forEach((group, optionIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const possible = variants.some((variant) => {
            const options = variantOptions(variant);
            if (options[optionIndex] !== input.value) return false;
            return selected.every((value, index) => index === optionIndex || !value || !options[index] || options[index] === value);
          });
          input.disabled = !possible;
          const label = group.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          label?.classList.toggle('is-unavailable', !possible);
          label?.setAttribute('aria-disabled', String(!possible));
        });
      });
    };

    const update = () => {
      const variant = currentVariant();
      optionGroups.forEach((group) => { const label = group.querySelector('[data-selected-option]'); if (label) label.textContent = group.querySelector('input:checked')?.value || ''; });
      if (!variant) {
        addButton.disabled = true;
        addText.textContent = window.theme.strings.unavailable;
        updateOptionAvailability();
        return;
      }
      variantInput.value = variant.id;
      addButton.disabled = !variant.available;
      addText.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      const price = scope.querySelector('[data-product-price]');
      const compare = scope.querySelector('[data-product-compare-price]');
      if (price) price.textContent = variant.price;
      if (compare) { compare.hidden = !variant.compare_at_price; compare.textContent = variant.compare_at_price || ''; }
      const sku = scope.querySelector('[data-product-sku]');
      const skuRow = scope.querySelector('[data-product-sku-row]');
      if (sku) sku.textContent = variant.sku || '';
      if (skuRow) skuRow.hidden = !variant.sku;
      const inventory = scope.querySelector('[data-product-inventory]');
      if (inventory) {
        inventory.textContent = variant.inventory_message || '';
        inventory.hidden = !variant.inventory_message;
      }
      updateOptionAvailability();
      const sticky = document.querySelector('[data-sticky-atc]');
      if (sticky && scope.closest('[data-main-product]')) {
        sticky.querySelector('[data-sticky-price]').textContent = variant.price;
        const stickyButton = sticky.querySelector('[data-sticky-submit]');
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      }
      if (variant.featured_media_id) document.querySelector(`[data-media-target="${variant.featured_media_id}"]`)?.click();
      if (scope.closest('[data-main-product]') && variant.url) history.replaceState({}, '', variant.url);
    };
    root.addEventListener('change', (event) => { if (event.target.name?.startsWith('options[')) update(); });
    update();
  });

  document.querySelectorAll('[data-media-target]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      gallery.querySelectorAll('[data-media-target]').forEach((tab) => tab.setAttribute('aria-selected', String(tab === button)));
      gallery.querySelectorAll('[data-media-id]').forEach((media) => { const active = media.dataset.mediaId === button.dataset.mediaTarget; media.hidden = !active; media.classList.toggle('is-active', active); });
    });
  });

  const mainForm = document.querySelector('[data-main-product] [data-product-form]');
  const sticky = document.querySelector('[data-sticky-atc]');
  const productSection = document.querySelector('[data-main-product]');
  if (mainForm && sticky && productSection) {
    sticky.hidden = false;
    let primaryControlsSeen = false;
    let previousScrollY = window.scrollY;
    const updateSticky = () => {
      const formRect = mainForm.getBoundingClientRect();
      const sectionRect = productSection.getBoundingClientRect();
      const scrollingDown = window.scrollY >= previousScrollY;
      if (formRect.top < window.innerHeight && formRect.bottom > 0) primaryControlsSeen = true;
      const passedPrimaryControls = formRect.bottom < 0;
      const withinProductSection = sectionRect.bottom > sticky.offsetHeight;
      sticky.classList.toggle('is-visible', primaryControlsSeen && passedPrimaryControls && withinProductSection && (scrollingDown || sticky.classList.contains('is-visible')));
      document.body.classList.toggle('has-sticky-atc', sticky.classList.contains('is-visible'));
      previousScrollY = window.scrollY;
    };
    const formObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) primaryControlsSeen = true;
      updateSticky();
    }, { threshold: 0.01 });
    formObserver.observe(mainForm);
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
    sticky.querySelector('[data-sticky-submit]')?.addEventListener('click', () => mainForm.querySelector('[type="submit"]')?.click());
  }
})();
